import { defineStore } from "pinia";
import { usePreviewStore } from "@/stores/preview";
import { useMergeTagsStore } from "@/stores/mergeTags";
import { useMjmlStore } from "./mjmlStore";

interface State {
  windowBar: string[]; //fullscreen, close
  removeTopBar: boolean;
  visibleTopBarElements: string[];
}

export const useTopBarStore = defineStore("topbar", {
  state: (): State => ({
    windowBar: [],
    removeTopBar: false,
    visibleTopBarElements: [],
  }),

  getters: {
    showWindowBar(): boolean {
      return this.windowBar.length > 0;
    },
    showMainTopBar(): boolean {
      if (this.removeTopBar) {
        return false;
      }
      if (this.visibleTopBarElements.length === 0) {
        return true;
      }

      const previewStore = usePreviewStore();

      if (!previewStore.previewMode) {
        const mjmlStore = useMjmlStore();
        return (
          this.visibleTopBarElements.filter((elem) => !elem.includes("preview"))
            .length !== 0 ||
          (mjmlStore.isMobileFirstEnabled &&
            this.visibleTopBarElements.includes("previewSize"))
        );
      }
      return (
        this.visibleTopBarElements.includes("changePreview") ||
        this.visibleTopBarElements.includes("previewSize")
      );
    },
    showPreviewTopBar(): boolean {
      if (this.visibleTopBarElements.length === 0) {
        return true;
      }

      const mergeTagsStore = useMergeTagsStore();
      const previewStore = usePreviewStore();
      if (
        this.visibleTopBarElements.filter((elem) =>
          elem.includes("previewTestMail")
        ).length !== 0 ||
        mergeTagsStore.enableMergeTagPreview ||
        previewStore.enableImageToTextRatio ||
        previewStore.enableDarkMode
      ) {
        return true;
      }

      return false;
    },
  },

  actions: {
    setWindowBar(windowBar: string[]) {
      this.windowBar = windowBar;
    },

    setRemoveTopBar(removeTopBar: boolean) {
      this.removeTopBar = removeTopBar;
    },

    setVisibleTopBarElements(visibleTopBarElements: string[]) {
      this.visibleTopBarElements = visibleTopBarElements;
    },
  },
});
